/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    stroke="currentColor"
    stroke-linecap="round"
    d="m21.9431 5.9773.9253 1.4961V2.5338c0-.1296.0939-.2532.2395-.2866l.0934-.0081c.1487.0072.2603.1085.2903.2266l.0084.091v5.0428h-5.2106c-.1866 0-.3158-.1442-.3158-.2951 0-.1296.0939-.2532.2394-.2866l.0981-.0085 2.6592.001.9025.0004-.4783-.7654C18.2842 1.2686 11.7382-.387 6.5975 2.5611 1.3519 5.5697-.448 12.236 2.5826 17.4504c3.0297 5.2125 9.7365 6.9959 14.9804 3.9885 2.822-1.6185 4.7285-4.3512 5.3059-7.4757.0297-.1605.187-.2721.356-.2413.1682.0307.2742.1888.2447.3484-.6088 3.294-2.6202 6.1782-5.5989 7.8865-5.5397 3.1771-12.6218 1.2904-15.8181-4.2091C-1.1427 12.2503.752 5.2192 6.2899 2.0432 11.7362-1.0804 18.6736.6907 21.943 5.9773Zm-9.7664 8.2703v.5h4.2744c.1439 0 .2549.115.2549.2499 0 .1348-.111.2498-.2549.2498h-4.7842V5.999c0-.135.111-.25.2549-.25.1439 0 .2549.115.2549.25v8.2486Z"
  />,
  'History'
);
